import { ReactNode, useMemo } from 'react'

import { Button } from '@/componentsV1/BaseComponents'
import { Separator } from '@/ui'

export const FormFlowFooter = ({
  onBack,
  onForward,
  continueDisabled,
  isSubmit,
  hideContinue = false,
  extraButton,
  loading,
  continueButtonText,
}: {
  onBack: () => void
  onForward?: () => void
  continueDisabled?: boolean
  isSubmit?: boolean
  hideContinue?: boolean
  extraButton?: ReactNode
  loading?: boolean
  continueButtonText?: string
}) => {
  const backButton = useMemo(
    () => (
      <Button variant="secondary" onClick={onBack} style={{ width: '100%' }}>
        Back
      </Button>
    ),
    [onBack]
  )

  const continueButton = useMemo(
    () =>
      !hideContinue && (
        <Button
          onClick={onForward}
          disabled={continueDisabled}
          loading={loading}
          style={{ width: '100%' }}
        >
          {continueButtonText || (isSubmit ? 'Submit' : 'Continue')}
        </Button>
      ),
    [
      continueDisabled,
      hideContinue,
      isSubmit,
      onForward,
      loading,
      continueButtonText,
    ]
  )

  return (
    <>
      <div className="w-full">
        <Separator />
      </div>

      {/* Mobile layout */}
      <div className="block md:hidden space-y-4 px-4">
        <div>{continueButton}</div>
        {extraButton && <div>{extraButton}</div>}
        <div>{backButton}</div>
      </div>

      {/* Tablet and up layout */}
      <div className="hidden md:flex items-center justify-between w-full gap-4">
        <div className="w-1/4 min-w-[150px]">{backButton}</div>
        {extraButton ? (
          <>
            <div className="w-1/8" />
            <div className="w-2/8 min-w-[150px]">{extraButton}</div>
            <div className="w-1/8" />
          </>
        ) : (
          <div className="w-2/4" />
        )}
        <div className="w-1/4 min-w-[150px] flex justify-end">
          {continueButton}
        </div>
      </div>
    </>
  )
}
